var video_controller = {
    init: function(dom){

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        if (width <= 1200){
            return;
        }

        var $dom = jQuery(dom);
        var bg_video_data = $dom.data('bg-video');
        if (bg_video_data){
            var decoded_html = atob(bg_video_data);
            if(decoded_html){
                var $decoded_html = jQuery(decoded_html);
                $decoded_html.on('loaded', function(){
                    $decoded_html.addClass('visible');
                });
                $decoded_html.on('error', function(){
                    console.error('Error loading background video');
                });
                $decoded_html.on('ended', function(){
                    $decoded_html.removeClass('visible');
                    setTimeout(function(){
                        $decoded_html[0].currentTime = 0;
                    }, 2000); // Small delay to ensure the video is not visible when resetting
                    setTimeout(function(){
                        $decoded_html[0].play();
                        setTimeout(function(){
                            $decoded_html.addClass('visible');
                        }, 100);
                    }, 10000);
                });
                $decoded_html.addClass('visible');
                $dom.replaceWith($decoded_html);
            }
        }
    }
}

jQuery(document).ready(function(){
    var video_wrappers = jQuery('.hero-background-video-wrapper');
    if(video_wrappers.length === 0){
        return;
    }
    video_wrappers.each(function(index, dom){
        video_controller.init(dom);
    });
});